// Rotina de cada status da Verificação de status (Adnéia, 17/10/2026, decisão 4 da página
// do Dashboard V2). Todo status é conferido todo dia útil; o que muda é quando se aciona
// alguém. Os DIAS de acionar vêm prontos do backend (`dias_acionar`, de _dias_acionar em
// routes/dashboard.py); aqui fica só o TEXTO do que fazer.
//   conf = o que se faz todo dia · acao = o que se faz no dia de acionar
//   nao  = aviso para status que não aciona ninguém
export const ROTINA = {
  'ag. parceiro': { conf: 'Conferir as pendências', acao: 'Cobrar o parceiro dos que têm pendência' },
  'enviado': { conf: 'Conferir', nao: 'Não aciona ninguém' },
  'aguardando': { conf: 'Conferir', nao: 'Não aciona ninguém', portal: 'Correios' },
  'ag. logística': { conf: 'Conferir', acao: 'Gerar o relatório e mandar para a Camila', lista: 'camila',
    nota: 'Fase 2: rever com o Matheus o que se analisa aqui.' },
  'em devolução - correios': { conf: 'Conferir', acao: 'Consultar nos Correios', portal: 'Correios' },
  'ag. confirmação de entrega': { conf: 'Conferir', acao: 'Mandar o comprovante ao cliente' },
  'ag. acionar o cliente': { conf: 'Conferir', acao: 'Acionar o cliente sobre o status' },
  'ag. transportadora - j&t': { conf: 'Dar uma olhada', acao: 'Cobrar a J&T', lista: 'J&T', portal: 'J&T' },
  'ag. transportadora - total': { conf: 'Dar uma olhada', acao: 'Cobrar a Total', lista: 'Total', portal: 'Total Express' },
  'ag. transportadora - asap': { conf: 'Dar uma olhada', acao: 'Cobrar a Asap', lista: 'Asap', portal: 'ASAP/CB' },
  'ag. barrar': { conf: 'Confirmar se o galpão barrou', acao: 'Cobrar o galpão, se precisar' },
  'ag. compras': { conf: 'Conferir se está tudo em aguardando estoque', nao: 'Não aciona: a Anna é acionada pela Mesa' },
  'ag. cliente': { conf: 'Ver rápido se o cliente respondeu', acao: 'Cobrar o cliente' },
  'entregue': { conf: 'Não devia ter nenhum', acao: 'Encerrar o chamado', encerrar: true },
  'em devolução - transp.': { conf: 'Conferir', acao: 'Cobrar a transportadora' },
  'ag. fornecedor': { conf: 'Ver se o fornecedor deu retorno', nao: 'Não aciona ninguém' },
};

// A Pendência de Transportadora segue no rodízio e, desde 29/10/2026, é feita na tela do
// ELO: a planilha "Pendências Transportadoras_2026" do SharePoint deixou de ser usada
// (Adnéia, 29/10/2026; de 17 a 28/10 o link abria a planilha).
export const TELA_PEND_TRANSP = '/pendencias-transportadora';

// O Atendimento é feito na planilha Cancelamento Geral do SharePoint, aba atendimento: o que é
// para trocar de transportadora vai ao Matheus e o que tem nova entrega se confere no BSeller
// (Adnéia, 04/11/2026; processos\atendimento-diario.md, passo 1).
export const PLANILHA_CANCELAMENTO_GERAL = 'https://weconnect360.sharepoint.com/:x:/r/sites/WeConnect/_layouts/15/Doc.aspx?sourcedoc=%7B28B1A63F-3497-4208-B821-9C2C79386FB9%7D&file=Cancelamento%20Geral%20(1).xlsx&action=default&mobileredirect=true';

// Canal sem portal é atendido por e-mail: o quadro dos canais abre o e-mail do atendimento
// no Outlook (link mandado pela Adnéia no chat, 23/10/2026). Gravar o portal na aba Acessos
// troca o canal para o link do portal.
export const EMAIL_ATENDIMENTO = 'https://outlook.office.com/mail/id/AAQkADZhNDcyNGJhLTUyNGYtNGVmNC1hYTViLWZjNTY4M2ZiNjJlMwAQALg9hqUnjKtLjnB98BdVK10%3D';

export const rotinaDe = (motivo) =>
  ROTINA[(motivo || '').trim().toLowerCase()] || { conf: 'Conferir', acao: 'Acionar' };

// Portal de cada canal ou transportadora, da aba Acessos ({ canal: link }). O nome do
// parceiro no chamado nem sempre é o nome do canal: aqui ficam as grafias conhecidas.
const MESMO_CANAL = { 'll': 'LL Loyalty', 'global rewards': 'GRS', 'vertem': 'LTM', 'itaú': 'LL Loyalty' };
export const linkDoPortal = (nome, portais) => {
  if (!nome || !portais) return '';
  const n = nome.trim().toLowerCase();
  const alvo = (MESMO_CANAL[n] || nome).trim().toLowerCase();
  const chave = Object.keys(portais).find(k => k.toLowerCase() === alvo);
  return chave ? portais[chave] : '';
};

// Em aberto de cada atividade da Verificação de atividades: Tem em Casa e as de saldo
// vêm contadas do backend (em_aberto); as outras se contam com as listas de retirada,
// pagamento e cancelamentos (as mesmas que o Dashboard carrega).
export const qtdAtividade = (r, { retirada, pagamento, cancelamentos } = {}) => {
  if (typeof r.em_aberto === 'number') return r.em_aberto;
  const m = r.motivo;
  const canc = (t) => (cancelamentos || []).filter(c => c.tipo === t && c.status !== 'encerrado').length;
  if (m === 'Cancelamentos (AES)' || m === 'AES (Compras)') return canc('aes');
  if (m === 'Falta na Produção (ETR)' || m === 'ETR (Produção)') return canc('etr');
  if (m === 'Erro na Nota') return canc('erro_nota');
  if (m === 'Disp. p/ Retirada') return (retirada || []).filter(p => !p.status_final).length;
  if (m === 'Pag. Não Aprovado') return (pagamento || []).filter(p => !p.status_final).length;
  return 0;
};

const NOMES_DIA = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];

// Próximo dia (depois de hoje) em que o status é acionado. Pula fim de semana; feriado
// a tela não conhece. dias = [1..5] (1 = segunda).
export const proximoAcionamento = (dias, hoje = new Date()) => {
  if (!dias || !dias.length) return null;
  const d = new Date(hoje);
  for (let i = 0; i < 14; i++) {
    d.setDate(d.getDate() + 1);
    const w = d.getDay();
    if (w !== 0 && w !== 6 && dias.includes(w)) {
      return `${NOMES_DIA[w]} ${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
    }
  }
  return null;
};

// Cor FIXA por pessoa (Adnéia, nota da página do Dashboard V2, 17/10/2026): o Caio é
// sempre azul e a Gabriela sempre laranja, seja qual for a lista do dia. Antes a cor
// seguia a lista e trocava de dono todo dia. Quem não está aqui (a gestão) fica roxo.
const COR_PESSOA = {
  caio: 'bg-blue-100 text-blue-800 dark:bg-blue-950/50 dark:text-blue-200',
  gabriela: 'bg-orange-100 text-orange-800 dark:bg-orange-950/50 dark:text-orange-200',
};
const COR_GESTAO = 'bg-violet-100 text-violet-800 dark:bg-violet-950/50 dark:text-violet-200';

export const primeiroNome = (nome) =>
  (nome || '').trim().split(/\s+/)[0].normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export const corPessoa = (nome) => COR_PESSOA[primeiroNome(nome)] || COR_GESTAO;

// Mesma cor, em versão de faixa (fundo e borda), para os cartões das Missões e o
// "Minhas demandas" do rodízio.
const FAIXA_PESSOA = {
  caio: 'bg-blue-50 border-blue-200 text-blue-900 dark:bg-blue-950/30 dark:border-blue-800 dark:text-blue-100',
  gabriela: 'bg-orange-50 border-orange-200 text-orange-900 dark:bg-orange-950/30 dark:border-orange-800 dark:text-orange-100',
};
const FAIXA_GESTAO = 'bg-violet-50 border-violet-200 text-violet-900 dark:bg-violet-950/30 dark:border-violet-800 dark:text-violet-100';

export const faixaPessoa = (nome) => FAIXA_PESSOA[primeiroNome(nome)] || FAIXA_GESTAO;

// Copiar que funciona também fora de https (mesmo jeito da Lista de Chamados).
export const copiarTexto = (text, onSuccess, onError) => {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).then(onSuccess).catch(onError);
    return;
  }
  const el = document.createElement('textarea');
  el.value = text;
  el.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;z-index:9999';
  document.body.appendChild(el);
  el.focus();
  el.select();
  el.setSelectionRange(0, text.length);
  const ok = document.execCommand('copy');
  document.body.removeChild(el);
  if (ok) onSuccess(); else onError();
};

// Baixa um xlsx gerado pelo backend (mesmo jeito dos relatórios da Lista de Chamados).
export const baixarBlob = (data, nome) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = nome;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
